export enum QRListStepperStageType {
    ActiveQrList = 1,
    ViewQRDetails = 2,
    GenerateQR = 3,
    ReviewQR = 4,
}
